import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Switch } from 'antd';
export const FormSwitch = ({ name, label, isRequired = false, disabled = false, rules = [], hidden = false, isRow = false, className = '', col = 24, responsive, style, value, onChange, ...props }) => {
    const validationRules = [
        ...(isRequired ? [{ required: true, message: `Vui lòng chọn ${label || name}` }] : []),
        ...rules
    ];
    const switchElement = (_jsx(Switch, { ...props, disabled: disabled, style: isRow ? { flex: 1 } : undefined, checked: value, onChange: onChange }));
    const colProps = responsive ?? { xs: col, sm: col, md: col, lg: col, xl: col, xxl: col };
    return (_jsx(Col, { ...colProps, style: { display: hidden ? 'none' : 'block' }, children: name ? (_jsx(Form.Item, { label: isRow ? undefined : label, name: name, valuePropName: 'checked', rules: validationRules, hidden: hidden, className: className, style: style, children: isRow ? (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [_jsxs("label", { style: {
                            minWidth: '20%',
                            fontWeight: 500,
                            marginBottom: 0,
                            whiteSpace: 'nowrap'
                        }, children: [label, isRequired && _jsx("span", { style: { color: 'red' }, children: " *" })] }), switchElement] })) : (switchElement) })) : (_jsxs("div", { style: {
                display: isRow ? 'flex' : 'block',
                alignItems: 'center',
                gap: 8
            }, children: [label && (_jsxs("label", { style: {
                        display: 'block',
                        fontWeight: 600,
                        fontSize: 13,
                        marginBottom: isRow ? 0 : 10,
                        whiteSpace: 'nowrap'
                    }, children: [label, isRequired && _jsx("span", { style: { color: 'red' }, children: " *" })] })), switchElement] })) }));
};
